// extracted by mini-css-extract-plugin
export default {"Elective":"QhNJNe3F6wCjoSwx5zee","Obligatory":"OJENtVkJ52naug8H8H6b","Accordion":"E3SXYKlp6hg80OhB5zCG"};